import { render, staticRenderFns } from "./CreateProjectButton.vue?vue&type=template&id=2b73e318"
import script from "./CreateProjectButton.vue?vue&type=script&lang=ts"
export * from "./CreateProjectButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports